// TODO fix browser downloading larger-than necessary image when sizes is limited by height

const autosizes = parameters => {
	
	return new Promise(resolve => {
		
		log('autosizes')
		
		// Handle parameters
		parameters = parameters || {}
		const defaults = {
			selector: '[data-sizes="auto"]',
			timeout: 1000,
			class: 'autosizes-on',
			loadingClass: 'autosizes-loading',
		}
		parameters = {...defaults, ...parameters}
		
		// Get images
		const images = document.querySelectorAll(parameters.selector)
		
		// Loop through images
		for (const image of images) {
			
			// Get CSS styles
			const style = getComputedStyle(image)
			
			// Get dimensions
			let dimensions = image.dataset.dimensions.split('x')
			let aspectRatio = dimensions[0] / dimensions[1]
			let masterWidth = dimensions[0]
			let masterHeight = dimensions[1]
			
			// Get sizes
			let width = image.scrollWidth
			let height = image.scrollHeight
			
			if (width === 0 && height === 0) continue
			
			log({image})
			log(`Image Size: ${width} x ${height}`)
			
			// Calculate sizes for object-fit images
			if (style.objectFit === "contain") {
				let containerAspectRatio = width / height
				if (aspectRatio > containerAspectRatio) {
					height = parseInt(width / aspectRatio)
				} else {
					width = parseInt(height * aspectRatio)
				}
			}
			if (style.objectFit === "cover") {
				let containerAspectRatio = width / height
				if (aspectRatio > containerAspectRatio) {
					width = parseInt(height * aspectRatio)
				} else {
					height = parseInt(width / aspectRatio)
				}
			}
			
			// If width is unknown
			if (width === 0 || image.classList.contains('orientation-landscape') && height > width) {
				
				if (height > 0) {
					// Use height to find width, if width isn't set
					height = parseInt(image.clientHeight)
				} else if (style.maxHeight != "none") {
					// If height isn't set, use max-height
					height = parseInt(style.maxHeight)
				} else {
					// Default
					height = 100
				}
				
				// Calculate width from height and aspect ratio
				width = Math.round((height * masterWidth) / masterHeight)
				
			}
			
			// Round result
			width = Math.round(width)
			
			// Set 'sizes' attribute
			image.setAttribute('sizes', `${width}px`)
			
			// Convert data attributes to actual attributes
			if (!image.classList.contains(parameters.class)) {
				const srcset = image.dataset.srcset
				image.setAttribute('srcset', srcset)
				delete image.dataset.srcset
				image.classList.add(parameters.class)
				image.classList.remove(parameters.loadingClass)
			}
			
			// Safari Fix
			// Sometimes Safari doesn't respect srcset changes
			// So we need to force an image repaint.
			setTimeout(() => {
				image.srcset = image.srcset
			}, 500)
			
		}
		
		resolve()
		
	})

}

export default autosizes


